// page.tsx
"use client";

import { useState, Suspense, lazy } from "react";
import LockScreen from "../../Components/Lockscreen";
import "./Vatican.css";

// import { VaticanMail } from "./VaticanAssets/VaticanMailContent";
import { VaticanMessageContent } from "./VaticanAssets/VaticanMessagesContent";
import { VaticanCallContent } from "./VaticanAssets/VaticanCallContent";
import { Chat_content } from "../../Components/MessageApp/MessagesInterfaces";
import { VaticanTweetContent } from "./VaticanAssets/VaticanTweeterContent";
import CallApp from "../../Components/CallApp/CallApp";
import { VaticanPhotoContent } from "./VaticanAssets/VaticanPhotoContent";
import { VaticanInternetContent } from "./VaticanAssets/VaticanInternetContent";
import HomeIcon from "../../Components/Icons/HomeIcon";
import TheGramApp from "../../Components/TheGramApp/TheGramApp";
import { VaticanTheGramContent } from "./VaticanAssets/VaticanGramContent";
import { recentSearches } from "./VaticanAssets/VaticanMapContent";
import Map from "./VaticanAssets/VaticanMapsAssets/Map-01.webp";

const Messages = lazy(() => import("../../Components/MessageApp/Messages"));
const Photos = lazy(() => import("../../Components/PhotosApp/Photos"));
const AppsMenu = lazy(
  () => import("../../Components/AppsMenu/AppsMenuVatican")
);
const TweeterApp = lazy(() => import("../../Components/TweeterApp/TweeterApp"));
const InternetApp = lazy(
  () => import("../../Components/InternetApps/VaticanInternetApp/InternetApp")
);
const MapsApp = lazy(() => import("../../Components/MapApp/MapsStatic"));

function Vatican() {
  const [isLocked, setIsLocked] = useState(true);
  const [activeApp, setActiveApp] = useState("appsmenu");
  const [messages, setMessages] = useState(VaticanMessageContent);
  const [messageNotifications, setMessageNotifications] = useState(0);

  const unlock = () => {
    setIsLocked(false);
  };

  const handleStateChange = (chat: Chat_content) => {
    const chatIndex = messages.findIndex(
      (message) => message.name === chat.name
    );
    const previousMessage = messages[chatIndex];
    if (previousMessage && !previousMessage.read) {
      const newMessages = [...messages];
      newMessages[chatIndex] = {
        ...newMessages[chatIndex],
        read: true,
      };
      setMessages(newMessages);
      setMessageNotifications(messageNotifications - 1);
    }
  };

  const renderApp = () => {
    switch (activeApp) {
      case "messages":
        return (
          <Messages
            influencerMessageContent={messages}
            theGram={false}
            handleStateChange={handleStateChange}
          />
        );

      case "phone":
        return <CallApp callContent={VaticanCallContent} />;
      case "photos":
        return <Photos albums={VaticanPhotoContent} />;
      case "maps":
        return <MapsApp mapImage={Map} recentSearches={recentSearches} />;

      case "appsmenu":
        return (
          <AppsMenu
            isLocked={isLocked}
            setActiveApp={setActiveApp}
            messageNotifications={messageNotifications}
          />
        );
      case "tweeter":
        return <TweeterApp tweeterContent={VaticanTweetContent} />;
      case "mail":
        return;
      case "thegram":
        return <TheGramApp content={VaticanTheGramContent} notifications={0} />;

      case "internet":
        return <InternetApp {...VaticanInternetContent} />;

      default:
        return null;
    }
  };

  return (
    <div className="Mystery">
      <div className="phone-wrapper">
        <div className={`Vaticanscreen ${activeApp}`}>
          {isLocked ? (
            <div
              className={`lockscreen-container ${
                isLocked ? "visible" : "hidden"
              }`}
            >
              <LockScreen
                unlock={unlock}
                password="158910"
                className="VaticanLockscreen"
              />
            </div>
          ) : null}

          <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                Loading...
              </div>
            }
          >
            {renderApp()}
          </Suspense>
          <div className="home-button-container">
            <HomeIcon onClick={() => setActiveApp("appsmenu")} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Vatican;
